module.exports = __webpack_public_path__ + "static/swapp-screens-c33fba7086beac2fa5cdb4e12d0de9f9.gif";